import React, { useState, useEffect } from "react";

import OrganizationProfileView from "../../components/OrganizationProfile/OrganizationProfileView";
import OrganizationProfileForm from "../../components/OrganizationProfile/OrganizationProfileForm";
import OrganizationsAPI from "../../API/organizations.api";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";

const OrganizationProfile = () => {
    const [editMode, setEditMode] = useState(false);
    const [countries, setCountries] = useState([]);
    const [flag, setFlag] = useState(null);
    const [organization, setOrganization] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();

    const externalOrganization = location.state?.organization || {};

    useEffect(() => {
        const isEdit = location.state?.isEdit || false;
        if (!isEmpty(externalOrganization)) {
            setOrganization(externalOrganization);
            setEditMode(isEdit);
            if (externalOrganization?.country)
                getFlag(externalOrganization?.country);
        } else {
            fetchData(isEdit);
        }
    }, []);

    useEffect(() => {
        if (!editMode) {
            fetchData();
        }
    }, [editMode]);

    const fetchData = async (isEdit) => {
        try {
            setIsLoading(true);
            let result = await OrganizationsAPI.getOrganizationInfo();
            if (result) {
                if (result.country) getFlag(result.country);
                setOrganization(result);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            if (isEdit) setEditMode(isEdit);
        }
    };

    const getFlag = async (country) => {
        if (isEmpty(country)) {
            setFlag("");
        } else {
            setFlag(
                <>
                    <div
                        className={`flag-icon flag-icon-${country.alpha2Code.toLowerCase()}`}
                    ></div>
                    <p className="w-6/12 text-justify inline mr-2">
                        {` ${country.label}`}
                    </p>
                </>
            );
        }
    };
    return (
        <>
            {editMode ? (
                <OrganizationProfileForm
                    organization={organization}
                    countries={countries}
                    setCountries={setCountries}
                    setEditMode={setEditMode}
                    flag={flag}
                    externalOrganization={externalOrganization}
                />
            ) : (
                <OrganizationProfileView
                    organization={organization}
                    setEditMode={setEditMode}
                    flag={flag}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};

export default OrganizationProfile;
